/**
 * Profile list + detail: years only when ≥12 months; months only when &lt;1 year (no mixed yr+mo).
 * Matches list row logic; use instead of API `experience_display` when parity is needed.
 */
export function formatSkillTenureFromMonths(experienceMonths: number): string {
  if (experienceMonths <= 0) return '0 mo'
  if (experienceMonths < 12) {
    return `${experienceMonths} ${experienceMonths === 1 ? 'month' : 'months'}`
  }
  const years = Math.floor(experienceMonths / 12)
  return `${years} ${years === 1 ? 'year' : 'years'}`
}
